import {
  zapFieldMappingRecipe,
  zapFieldMappingToolsAtom,
} from "./zapRecipe/zapRecipe";
import {
  buildZapSkeletonToolsAtom,
  buildZapSkeleton,
} from "./buildZapSkeleton/buildZapSkeleton";
import {
  interfaceSetupToolsAtom,
  interfaceSetupRecipe,
} from "./interfaceSetup/interfaceSetup";
import {
  tablesOperationsToolsAtom,
  tablesOperationsRecipe,
} from "./tablesOperations/tablesOperations";
import {
  authenticationOperationsToolsAtom,
  authenticationOperationsRecipe,
} from "./authenticationOperations/authenticationOperations";
import {
  ZapFieldMapping,
  BuildZapSkeleton,
  InterfaceSetup,
  TablesOperations,
  AuthenticationOperations,
  rawRecipeData,
} from "./recipe_definitions_raw";
import { JotaiTool } from "../../../index";
import { Atom } from "jotai";

const recipeExtensions: Record<
  | typeof ZapFieldMapping
  | typeof BuildZapSkeleton
  | typeof InterfaceSetup
  | typeof TablesOperations
  | typeof AuthenticationOperations,
  { toolsAtom?: Atom<JotaiTool<any>[]>; fullInstructions: string }
> = {
  [ZapFieldMapping]: {
    toolsAtom: zapFieldMappingToolsAtom,
    fullInstructions: zapFieldMappingRecipe,
  },
  [BuildZapSkeleton]: {
    toolsAtom: buildZapSkeletonToolsAtom,
    fullInstructions: buildZapSkeleton,
  },
  [InterfaceSetup]: {
    toolsAtom: interfaceSetupToolsAtom,
    fullInstructions: interfaceSetupRecipe,
  },
  [TablesOperations]: {
    toolsAtom: tablesOperationsToolsAtom,
    fullInstructions: tablesOperationsRecipe,
  },
  [AuthenticationOperations]: {
    toolsAtom: authenticationOperationsToolsAtom,
    fullInstructions: authenticationOperationsRecipe,
  },
};

export const recipeDefinitionsFull = rawRecipeData.map((recipe) => {
  return {
    ...recipe,
    ...recipeExtensions[recipe.id],
  };
});
